import { TaskListWidgetComponent } from './task-list-widget/task-list-widget.component';
import { SharedModule } from './../shared/shared.module';
import { TaskAssignComponent } from './task-assign/task-assign.component';
import { TaskListComponent } from './task-list/task-list.component';
import { NgModule } from '@angular/core';
import { TaskDetailComponent } from './task-detail/task-detail.component';
import { TaskListService } from '../core/service/grid-data/grid-data-task.service';
import { TaskDuedateComponent } from './task-duedate/task-duedate.component';
import { ContactHistoryModule } from '../contact-history/contact-history.module';
import { EditorModule } from '@progress/kendo-angular-editor';
import { DocumentModule } from '../document/document.module';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { TaskDetailFollowUpListComponent } from './task-detail/task-detail-followup-list/task-detail-followup-list.component';
import { TaskDetailRelatedToComponent } from './task-detail/task-detail-related-to/task-detail-related-to.component';
import { TaskPriorityComponent } from './task-priority/task-priority.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TaskListDetailComponent } from './task-list-detail/task-list-detail.component';
import { SendEmailModule } from '../shared/send-document/send-document.module';
import { ReferralModule } from '../referral/referral.module';
import { TaskListReferralComponent } from './task-list-referral/task-list-referral.component';
import { ReferralTaskListService } from '../core/service/grid-data/grid-data-referral-task.service';
import { CaseEnrollmentModule } from '../shared/case-enrollment/case-enrollment.module';
import { MemberAssessmentModule } from '../shared/member-assessment/member-assessment.module';
import { TaskAddModule } from '../shared/task-add/task-add.module';
import { MessageModule } from '../message/message.module';
import { TaskDetailServicesProvidedComponent } from './task-detail/task-detail-services-provided/task-detail-services-provided.component';
import { AccumulatorGridModule } from '../shared/accumulator-grid/accumulator-grid.module';
import { PatientEligibilityModule } from '../shared/patient-eligibility/patient-eligibility.module';
import { TaskForceCloseComponent } from './task-force-close/task-force-close.component';

@NgModule({
  imports: [
    SharedModule,
    ContactHistoryModule,
    EditorModule,
    DocumentModule,
    NgxJsonViewerModule,
    NgbModule,
    MemberAssessmentModule,
    SendEmailModule,
    ReferralModule,
    CaseEnrollmentModule,
    TaskAddModule,
    MessageModule,
    AccumulatorGridModule,
    PatientEligibilityModule
  ],
  declarations: [
    TaskDetailComponent,
    TaskListComponent,
    TaskAssignComponent,
    TaskDuedateComponent,
    TaskDetailFollowUpListComponent,
    TaskDetailRelatedToComponent,
    TaskListWidgetComponent,
    TaskPriorityComponent,
    TaskListDetailComponent,
    TaskListReferralComponent,
    TaskDetailServicesProvidedComponent,
    TaskForceCloseComponent,
  ],
  providers: [
    ReferralTaskListService,
    TaskListService
  ],
  exports: [
    TaskDetailComponent,
    TaskListComponent,
    TaskAssignComponent,
    TaskDuedateComponent,
    TaskListWidgetComponent,
    TaskPriorityComponent,
    TaskListDetailComponent,
    TaskForceCloseComponent,
  ]
})
export class TaskModule { }
